import React from 'react'
import './Cardcontainer.css'



function Cardcontainer({children}){

    
    return(
        <div className='card-container'>
            {children}
        </div>
    )
}

export default Cardcontainer